import { render } from "./SessionPreview.vue?vue&type=template&id=523c77f0&scoped=true"
import script from "./SessionPreview.vue?vue&type=script&lang=js"
export * from "./SessionPreview.vue?vue&type=script&lang=js"

import "./SessionPreview.vue?vue&type=style&index=0&id=523c77f0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523c77f0"]])

export default __exports__